var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { id: "login" } }, [
    _c("div", { staticClass: "login-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "login-form" }, [
        _c(
          "div",
          { staticClass: "form-stemdo", attrs: { role: "form" } },
          [
            _c("div", { staticClass: "form-title" }, [
              _c("h1", {
                domProps: { textContent: _vm._s(_vm.$t("login.title")) },
              }),
              _vm._v(" "),
              _vm.errorMessage
                ? _c("div", { staticClass: "login-error" }, [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t("login.messages.error.message")
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.requestOtpMessage
              ? _c("div", { staticClass: "login-request" }, [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.$t("login.password.request")),
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("label", {
                staticClass: "login-span",
                attrs: { for: "input-form-stemdo" },
                domProps: {
                  textContent: _vm._s(_vm.$t("login.form['username']")),
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "input-form-group-stemdo pb-6",
                  attrs: { id: "inpunts" },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.$v.username.$model,
                        expression: "$v.username.$model",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "input-form-stemdo is-invalid",
                    class: {
                      "input-error":
                        !_vm.$v.username.email ||
                        (_vm.isFormInvalid && !_vm.$v.username.email.$model),
                    },
                    attrs: {
                      id: "input-form-stemdo",
                      type: "email",
                      name: "login",
                      "data-cy": "usernameLogin",
                      "placeholder-for": "username",
                      autofocus: "",
                    },
                    domProps: { value: _vm.$v.username.$model },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.$v.username,
                          "$model",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  !_vm.$v.username.email ||
                  (_vm.$v.username.email.model && !_vm.isFormInvalid)
                    ? _c("span", {
                        staticClass: "span-error",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("global.messages.validate.email.required")
                          ),
                        },
                      })
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("SButton", {
              attrs: {
                btnStyle: "primary",
                sText: "login.form.button",
                action: _vm.validateForm,
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "login-image" }, [
      _c("img", {
        attrs: {
          src: require("@content/images/stemdo-black-logo.png"),
          alt: "stemdo Logo",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }